import { createMedia, createFonts } from '@shipae/components-sandbox';

export const DEFAULT_FONT_SIZE = 20;
export const media = createMedia();
export const fonts = createFonts(DEFAULT_FONT_SIZE);
